/* cwc-scrollable */
* {
  box-sizing: border-box;
}

$scrollbar-width: 16px !default;

:host {
  --fade-in-transition-duration: 150ms;
  --fade-out-transition-duration: 800ms;
  --fade-out-transition-delay: 300ms;
  --fill-color-transition-duration: 150ms;

  --viewport-overflow-x: auto;
  --viewport-overflow-y: auto;
  --viewport-scroll-snap-type: none;
  --viewport-scroll-behavior: auto;
  --viewport-overscroll-behavior: auto;

  --scrollbar-padding: 2px;
  --scrollbar-fill-color: transparent;
  --scrollbar-fill-color-hover: transparent;
  --scrollbar-border-width: 0;
  --scrollbar-border-style: none;
  --scrollbar-border-color: #999;
  --scrollbar-border-radius: 0;
  --scrollbar-box-shadow: none;
  --vertical-scrollbar-background: none;
  --vertical-scrollbar-background-size: auto;
  --horizontal-scrollbar-background: none;
  --horizontal-scrollbar-background-size: auto;

  --scrollbar-track-fill-color: transparent;
  --scrollbar-track-fill-color-hover: transparent;
  --scrollbar-track-border-width: 0;
  --scrollbar-track-border-style: none;
  --scrollbar-track-border-color: #999;
  --scrollbar-track-border-radius: 0;
  --scrollbar-track-box-shadow: none;
  --vertical-scrollbar-track-background: none;
  --vertical-scrollbar-track-background-size: auto;
  --horizontal-scrollbar-track-background: none;
  --horizontal-scrollbar-track-background-size: auto;

  --scrollbar-thumb-fill-color: var(--cwc-scrollable-scrollbar-thumb-fill-color, #ccc);
  --scrollbar-thumb-fill-color-hover: var(--cwc-scrollable-scrollbar-thumb-fill-color-hover, #aaa);
  --scrollbar-thumb-border-width: 0;
  --scrollbar-thumb-border-style: none;
  --scrollbar-thumb-border-color: #999;
  --scrollbar-thumb-border-radius: var(--scrollbar-width, #{$scrollbar-width});
  --scrollbar-thumb-box-shadow: none;
  --vertical-scrollbar-thumb-background: none;
  --vertical-scrollbar-thumb-background-size: auto;
  --horizontal-scrollbar-thumb-background: none;
  --horizontal-scrollbar-thumb-background-size: auto;

  --content-padding: 0;
  display: flex;

  position: relative;
  grid-template: 1fr / 1fr;
  overflow: hidden;
}

@keyframes fadeIn {
  0% {
    opacity: 0.01;
  }

  100% {
    opacity: 1;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0.01;
  }

  100% {
    opacity: 1;
  }
}

:host([disable-vertical-scrollbar]) {
  cwc-scrollable-bar[vertical-scrollbar] {
    display: none !important;
  }
}

:host([disable-horizontal-scrollbar]) {
  cwc-scrollable-bar[horizontal-scrollbar] {
    display: none !important;
  }
}

/* Viewport */
cwc-scrollable-viewport {
  display: flex;
  z-index: 0;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  overflow-x: var(--viewport-overflow-x);
  overflow-y: var(--viewport-overflow-y);
  outline: none;
  pointer-events: all;
  scrollbar-width: none;
  scroll-behavior: var(--viewport-scroll-behavior);
  overscroll-behavior: var(--viewport-overscroll-behavior);
  scroll-snap-type: var(--viewport-scroll-snap-type);
}

cwc-scrollable-viewport::-webkit-scrollbar,
cwc-scrollable-content::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

cwc-scrollable-viewport:hover,
cwc-scrollable-viewport:not(:focus):focus-within,
cwc-scrollable-viewport[touch],
cwc-scrollable-viewport[scrolling-with-vertical-thumb],
cwc-scrollable-viewport[scrolling-with-horizontal-thumb] {
  will-change: scroll-position;
}

cwc-scrollable-viewport[scrolling-with-vertical-thumb],
cwc-scrollable-viewport[scrolling-with-horizontal-thumb] {
  pointer-events: none;
}

/* Content */
cwc-scrollable-content {
  display: flex;
  margin-right: auto;
  margin-left: auto;
  padding: var(--content-padding);
  animation-name: fadeIn;
  animation-duration: 300ms;
  animation-delay: 400ms;
  opacity: 0.01;
  animation-fill-mode: forwards;

  &:not(.no-aspect-ratio) {
    width: var(--viewport-width);
  }
}

/* Scrollbar */
cwc-scrollable-bar {
  position: absolute;
  padding: var(--scrollbar-padding);
  transition:
    opacity var(--fade-out-transition-duration) ease-in-out var(--fade-out-transition-delay),
    background-color var(--fill-color-transition-duration) ease-out;
  border-width: var(--scrollbar-border-width);
  border-style: var(--scrollbar-border-style);
  border-radius: var(--scrollbar-border-radius);
  border-color: var(--scrollbar-border-color);
  opacity: 0;
  box-shadow: var(--scrollbar-box-shadow);
  pointer-events: all;
  user-select: none;
}

[vertical-scrollbar] {
  z-index: 20;
  top: 0;
  right: 0;
  bottom: 0;
  width: var(--scrollbar-width, #{$scrollbar-width});
  background: var(--vertical-scrollbar-background);
  background-color: var(--scrollbar-fill-color);
  background-size: var(--vertical-scrollbar-background-size);
}

[vertical-scrollbar][left-position] {
  right: auto;
  left: 0;
}

[horizontal-scrollbar] {
  z-index: 10;
  right: 0;
  bottom: 0;
  left: 0;
  height: var(--scrollbar-width, #{$scrollbar-width});
  background: var(--horizontal-scrollbar-background);
  background-color: var(--scrollbar-fill-color);
  background-size: var(--horizontal-scrollbar-background-size);
}

[horizontal-scrollbar]:not([hidden]) ~ cwc-scrollable-viewport {
  /* If there is a horizontal scrollbar, the viewport is allowed to take 100% of the height - except the scrollbar's width. */
  height: calc(100% - var(--scrollbar-width, #{$scrollbar-width}));
}

[horizontal-scrollbar][hidden] ~ cwc-scrollable-viewport {
  /* If there is no horizontal scrollbar, the viewport is allowed to take 100% of the height. */
  height: 100%;
}

[horizontal-scrollbar][top-position] {
  top: 0;
  bottom: auto;
}

cwc-scrollable-bar:hover,
cwc-scrollable-bar[scrolling-with-thumb] {
  transition:
    opacity var(--fade-in-transition-duration) ease-in-out 0s,
    background-color var(--fill-color-transition-duration) ease-out;
  opacity: 1;
  will-change: opacity;
}

cwc-scrollable-viewport:hover,
cwc-scrollable-viewport:not(:focus):focus-within,
cwc-scrollable-viewport[touch] {
  @at-root cwc-scrollable-bar {
    transition:
      opacity var(--fade-in-transition-duration) ease-in-out 0s,
      background-color var(--fill-color-transition-duration) ease-out;
    opacity: 1;
    will-change: opacity;
  }
}

cwc-scrollable-viewport[scrollbar-visible] {
  @at-root cwc-scrollable-bar {
    transition: none;
    opacity: 1;
  }
}

cwc-scrollable-bar:hover,
cwc-scrollable-bar[scrolling-with-thumb] {
  z-index: 30;
  background-color: var(--scrollbar-fill-color-hover);
}

cwc-scrollable-bar[hidden] {
  display: none;
}

cwc-scrollable-bar cwc-scrollable-track {
  display: flex;
  width: 100%;
  height: 100%;
  transition: background-color var(--fill-color-transition-duration) ease-out;
  border-width: var(--scrollbar-track-border-width);
  border-style: var(--scrollbar-track-border-style);
  border-radius: var(--scrollbar-track-border-radius);
  border-color: var(--scrollbar-track-border-color);
  box-shadow: var(--scrollbar-track-box-shadow);
}

/* Scrollbar's track */
[vertical-scrollbar] cwc-scrollable-track {
  background: var(--vertical-scrollbar-track-background);
  background-color: var(--scrollbar-track-fill-color);
  background-size: var(--vertical-scrollbar-track-background-size);
}

[horizontal-scrollbar] cwc-scrollable-track {
  background: var(--horizontal-scrollbar-track-background);
  background-color: var(--scrollbar-track-fill-color);
  background-size: var(--horizontal-scrollbar-track-background-size);
}

cwc-scrollable-track:hover,
cwc-scrollable-bar[scrolling-with-thumb] cwc-scrollable-track {
  background-color: var(--scrollbar-track-fill-color-hover);
}

/* Scrollbar's thumb */
cwc-scrollable-bar cwc-scrollable-thumb {
  width: 100%;
  height: 100%;
  transform: translate3d(0, 0, 0);
  transition: background-color var(--fill-color-transition-duration) ease-out;
  border-width: var(--scrollbar-thumb-border-width);
  border-style: var(--scrollbar-thumb-border-style);
  border-radius: var(--scrollbar-thumb-border-radius);
  border-color: var(--scrollbar-thumb-border-color);
  box-shadow: var(--scrollbar-thumb-box-shadow);
}

[vertical-scrollbar] cwc-scrollable-thumb {
  background: var(--vertical-scrollbar-thumb-background);
  background-color: var(--scrollbar-thumb-fill-color);
  background-size: var(--vertical-scrollbar-thumb-background-size);
}

[horizontal-scrollbar] cwc-scrollable-thumb {
  background: var(--horizontal-scrollbar-thumb-background);
  background-color: var(--scrollbar-thumb-fill-color);
  background-size: var(--horizontal-scrollbar-thumb-background-size);
}

cwc-scrollable-bar cwc-scrollable-thumb:hover,
cwc-scrollable-bar[scrolling-with-thumb] cwc-scrollable-thumb {
  background-color: var(--scrollbar-thumb-fill-color-hover);
}
